<template>
  <div id="wrapper" class="page" v-if="project_customer_read">
    <!-- <contract-side-bar index="2" /> -->
    <div id="content-wrapper">
      <div class="container-fluid">
        <div class="form-inline">
          <button class="btn btn-info mb-2 mr-2" @click.prevent="openModal">
            <i class="fas fa-plus"></i>
            Add
            <!-- Thêm -->
          </button>
          <!-- <div style="flex-grow: 1" /> -->
          <button class="btn btn-success mb-2" @click.prevent="openReportModal">
            <i class="far fa-file-alt"></i> Report
          </button>
        </div>

        <b-row>
          <b-col cols="12">
            <div class="form-inline" style="width: 100%">
              <b-form-input
                style="flex-grow: 1"
                v-model="query"
                placeholder="Search by customer"
                @keydown.enter.prevent="queryItem"
              ></b-form-input>
              <button class="btn" @click.prevent="queryItem">
                <i class="fas fa-search"></i>
              </button>
              <!-- <button class="btn" id="popover-target-1">
                  <i class="fas fa-filter"></i>
                </button> -->
            </div>
          </b-col>
        </b-row>
        <b-table
          id="my-table"
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="fields"
          :items="items"
          @sort-changed="sortChanged"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template #cell(STT)="data">{{ data.index + 1 }}</template>
          <template v-slot:cell(ten)="data">
                <b-link href="#" @click.prevent="openUpdateModal(data)" class= "link">
                    {{data.value}}
                </b-link>
          </template>
          <template v-slot:cell(doitac)="data">{{
            findFirstDepartment(departments, data.value)
          }}</template>
          <template #cell(favorite)="data">
                <i v-if="data.value == 1"
                  class="fas fa-heart text-danger"
                ></i>
              </template>
          <template v-slot:cell(action)="data">
            <b-link
              class="text-primary mr-2"
              href="#"
              @click="openUpdateModal(data)"
            >
              <i class="fas fa-pencil-alt"></i>
            </b-link>
            <b-link
              class="text-danger"
              href="#"
              @click.prevent="deleteItem(data)"
            >
              <i class="fas fa-trash"></i>
            </b-link>
            <!-- <button class="btn btn-info mr-1" @click="openUpdateModal(data)">
              <i class="fas fa-pencil-alt"></i>
            </button>
            <button class="btn btn-danger" @click="deleteItem(data)">
              <i class="fas fa-trashalt"></i>
            </button> -->
          </template>
        </b-table>
        <b-badge v-if="totalRow != 0" variant="light"
          >
          Total: {{ totalRow }}
          <!-- Tổng số khách hàng: {{ totalRow }} -->
          </b-badge
        >


      </div>
    </div>
    <div>
      <b-modal
        v-model="modalShow"
        header-bg-variant="info"
        header-text-variant="light"
        size="xl"
        hide-footer
      >
        <template v-slot:modal-title>
          <div v-if="item.id <= 0">
            Add customer
            <!-- Thêm thông tin khách hàng -->
          </div>
          <div v-else>
            Update customer
            <!-- Cập nhật thông tin khách hàng -->
          </div>
        </template>
        <b-container>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Company
                <!-- Tên công ty -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="10">
              <b-form-input v-model="item.ten" required></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Address
                <!-- Địa chỉ -->
              </label>
            </b-col>
            <b-col cols="10">
              <b-form-input v-model="item.diachi" required></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Tax code
                <!-- MST -->
              </label>
            </b-col>
            <b-col cols="3">
              <b-form-input v-model="item.masothue" required></b-form-input>
            </b-col>
            <b-col cols="1"></b-col>
            <b-col cols="2">
              <label class="mr-2">
                Partner of
                <!-- Đối tác của -->
              </label>
            </b-col>
            <b-col cols="4">
              <b-form-select
                v-model="item.doitac"
                :options="departments"
                value-field="id"
                text-field="tendonvi"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null"></b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                VIP
                <!-- Quan trọng -->
              </label>
            </b-col>
            <b-col cols="3">
              <b-link
                  href="#"
                  @click="changeFavorite">
                  <i  class="fas fa-heart fa-lg"
                      v-bind:class="{ 'text-muted': item.favorite == 0, 'text-danger': item.favorite == 1 }">
                  </i>
              </b-link>
            </b-col>
          </b-row>
        </b-container>
        <button class="btn btn-info mb-2" @click.prevent="openLienHeModal">
          <i class="fas fa-plus"></i>
          Add contact information
          <!-- Thêm thông tin liên hệ -->
        </button>
        <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          :fields="lienheFields"
          :items="item.customerContacts"
          table-variant="light"
        >
          <!-- <template v-slot:cell(ten)="data">
            <b-link href="#" @click="openUpdateModalLienHe(data)">{{data.value}}</b-link>
          </template> -->
          <!-- <template v-slot:cell(ngaysinh)="data">
            {{ data.item.ngaysinh | moment("DD/MM/YYYY") }}
          </template> -->
          <template #cell(favorite)="data">
            <i v-if="data.value == 1"
              class="fas fa-heart text-danger"
            ></i>
          </template>
          <template v-slot:cell(action)="data">
            <b-link
              class="text-primary mr-2"
              href="#"
              @click="openUpdateModalLienHe(data)"
            >
              <i class="fas fa-pencil-alt"></i>
            </b-link>
            <b-link
              class="text-danger"
              href="#"
              @click.prevent="deleteItemLienHe(data)"
            >
              <i class="fas fa-trash"></i>
            </b-link>
          </template>
        </b-table>
        <div class="form-inline">
          <div style="flex-grow: 1"></div>
          <b-button class="mr-3" variant="info" @click.prevent="storeItem">
            <i class="fas fa-save mr-2"></i>Save
            <!-- Lưu -->
          </b-button>
          <b-button variant="secondary" @click="closeModal">
            <i class="fas fa-times mr-2"></i>Close
            <!-- Đóng -->
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        v-model="modalLienHeShow"
        header-bg-variant="info"
        header-text-variant="light"
        size="xl"
        hide-footer
      >
        <template v-slot:modal-title>
          <div v-if="modalLienHeStatus == 0">
            Add contact information
            <!-- Thêm thông tin liên hệ -->
          </div>
          <div v-else>
            Update contact information
            <!-- Cập nhật thông tin liên hệ -->
          </div>
        </template>
        <b-container>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Name
                <!-- Họ và tên -->
              </label>
              <code>*</code>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="itemLienHe.ten"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Position
                <!-- Chức danh -->
              </label>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="itemLienHe.chucdanh"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Phone
                <!-- Điện thoại -->
              </label>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="itemLienHe.dienthoai"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">Email</label>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="itemLienHe.email"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Date of birth
                <!-- Ngày sinh -->
              </label>
            </b-col>
            <b-col cols="9">
              <my-date-picker v-model="itemLienHe.ngaysinh"></my-date-picker>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                Address
                <!-- Địa chỉ nhà -->
              </label>
            </b-col>
            <b-col cols="9">
              <b-form-input v-model="itemLienHe.diachi"></b-form-input>
            </b-col>
          </b-row>

           <b-row class="mb-4">
            <b-col cols="2">
              <label class="mr-2">
                VIP
                <!-- Quan trọng -->
              </label>
            </b-col>
            <b-col cols="3">
              <b-link
                  href="#"
                  @click="changeFavoriteItemLienHe">
                  <i  class="fas fa-heart fa-lg"
                      v-bind:class="{ 'text-muted': itemLienHe.favorite == 0, 'text-danger': itemLienHe.favorite == 1 }">
                  </i>
              </b-link>
            </b-col>
          </b-row>

        </b-container>
        <div class="form-inline">
          <div style="flex-grow: 1"></div>
          <b-button
            class="mr-3"
            variant="info"
            @click.prevent="storeItemLienHe"
            v-if="modalLienHeStatus == 0"
          >
            <i class="fas fa-save mr-2"></i>
            Save
            <!-- Lưu -->
          </b-button>
          <b-button
            class="mr-3"
            variant="info"
            @click.prevent="updateItemLienHe"
            v-if="modalLienHeStatus == 1"
          >
            <i class="fas fa-save mr-2"></i>Save
            <!-- Lưu -->
          </b-button>
          <b-button variant="secondary" @click="closeModalLienHe">
            <i class="fas fa-times mr-2"></i>Close
            <!-- Đóng -->
          </b-button>
        </div>
      </b-modal>

      <!-- REPORT MODAL -->
      <b-modal
        v-model="reportModalShow"
        header-bg-variant="primary"
        header-text-variant="light"
        hide-footer
        title="CUSTOMER REPORT"
        text-center
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Customer Type
                  <!-- Loại khách hàng -->
                </b>
                <span class="text-danger">*</span>
              </template>
              <b-form-select v-model="type" :options="types" value-field="id" text-field="type" @change="getCustomerFromType"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="customer_visibled">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Name
                  <!-- Tên khách hàng -->
                </b>
                <span class="text-danger">*</span>
              </template>
              <b-form-select v-model="customer" :options="customers" value-field="id" text-field="ten">
                <template #first>
                  <b-form-select-option :value="null">
                    All
                    <!-- Tất cả -->
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="customer_visibled">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <b>
                  Key contact
                  <!-- Loại người phụ trách -->
                </b>
                <span class="text-danger">*</span>
              </template>
              <b-col cols="4">
                <input type="radio" class="mr-2" id="one" :value="0" v-model="agent_picked">
                <label for="one">
                  All
                  <!-- Tất cả -->
                </label>
              </b-col>
              <b-col cols="4">
                <input type="radio" class="mr-2" id="two" :value="1" v-model="agent_picked">
                <label for="two">
                  VIP
                  <!-- Quan trọng -->
                </label>
              </b-col>
              <b-col cols="4">
                <input type="radio" class="mr-2" id="three" :value="2" v-model="agent_picked">
                <label for="three">
                  Normal
                  <!-- Thông thường -->
                </label>
              </b-col>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-button class="mr-2" variant="info" @click.prevent="selectCustomer">
                <i class="fas fa-check mr-2"></i>Select
                <!-- Chọn -->
              </b-button>
              <b-button class="mr-2" variant="secondary" @click.prevent="closeReportModal">
                <i class="fas fa-times mr-2"></i>Close
                <!-- Đóng -->
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
      <!-- END OF REPORT MODAL -->

      <!-- CUSTOMER MODAL -->
      <b-modal
        size="xl"
        v-model="customerModalShow"
        header-bg-variant="primary"
        header-text-variant="light"
        hide-footer
        title="CUSTOMER INFORMATION"
        text-center
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
        <b-row>
          <b-col>
            <b-form-group>
              <b-button class="mr-2" variant="secondary" @click.prevent="closeCustomerModal" style="float:right;">
                <i class="fas fa-times mr-2"></i>Close
                <!-- Đóng -->
              </b-button>
              <b-button class="mr-2" variant="success" @click.prevent="excelReport" style="float:right;">
                <i class="far fa-file-excel mr-2"></i>
                Export to Excel
                <!-- Xuất Excel -->
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>

        <danh-sach-khach-hang :customer="customer" :customer_array="customers" :agent="agent_picked" :is_all_customer="is_all_customer"></danh-sach-khach-hang>
      </b-modal>
      <!-- END OF CUSTOMER MODAL -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import ContractSideBar from "../components/Contract/ContractSideBar";
import MyDatePicker from "../components/App/MyDatePicker";
import DanhSachKhachHang from "../components/Project/Report/Report1";

export default {
  name: "Customers",
  components: {
    // ContractSideBar,
    MyDatePicker,
    DanhSachKhachHang,
  },
  data() {
    return {
      fields: [
        {
          key: "STT",
          label: "No.",
          // label: "STT",1
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "ten",
          label: "Name",
          // label: "Tên công ty",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "420px", textAlign: "center" },
        },

        {
          key: "diachi",
          label: "Address",
          // label: "Địa chỉ",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },

        {
          key: "masothue",
          label: "Tax code",
          // label: "MST",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "150px", textAlign: "center" },
        },
        {
          key: "doitac",
          label: "Partner of",
          // label: "Đối tác của",
          sortable: true,
          thClass: "align-middle",
          tdClass: "text-center",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "favorite",
          label: "VIP",
          // label: "Quan trọng",
          sortable: true,
          thClass: "align-middle",
          tdClass: "text-center",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "75px !important", textAlign: "center" },
        },
      ],
      items: [],

      // Report variable
      types: [  {id: 0, type: "All"},
               {id: 1, type: "VIP"},
              {id: 2, type: "Normal"},
              {id: 3, type: "Customers don't have a contract of more than 1 year"},],
      // types: [{id: 0, type: "Tất cả"}, {id: 1, type: "Khách hàng quan trọng"}, {id: 2, type: "Khách hàng thông thường"}, {id: 3, type: "Khách hàng không có hợp đồng quá 1 năm"},],
      type: null,
      customers: [],
      customer: null,
      is_all_customer: false,
      customer_visibled: false,
      agent_picked: 0,

      item_null: {
        id: 0,
        ten: null,
        diachi: null,
        masothue: null,
        doitac: null,
        customerContacts: [],
        favorite: 0,
      },
      item: {
        id: 0,
        ten: null,
        diachi: null,
        masothue: null,
        doitac: null,
        customerContacts: [],
      },
      modalShow: false,
      reportModalShow: false,
      customerModalShow: false,
      url: "/api/customer/",
      departments: [],
      lienheFields: [
        {
          key: "ten",
          label: "Name",
          // label: "Họ và tên",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign: "center" },
        },
        {
          key: "chucdanh",
          label: "Position",
          // label: "Chức danh",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "200px", textAlign: "center" },
        },
        {
          key: "dienthoai",
          label: "Phone",
          // label: "Điện thoại",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "180px", textAlign: "center" },
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "220px", textAlign: "center" },
        },
        {
          key: "favorite",
          label: "VIP",
          // label: "Quan trọng",
          sortable: true,
          thClass: "align-middle",
          tdClass: "text-center",
          thStyle: { width: "140px", textAlign: "center" },
        },

        // {
        //   key: "ngaysinh",
        //   label: "Ngày sinh",
        //   sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "120px", textAlign: "center" },
        // },
        // {
        //   key: "diachi",
        //   label: "Địa chỉ nhà",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {textAlign: "center" },
        // },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {width: "75px !important" , textAlign : "center"},
        },
      ],
      lienHeItems: [],
      itemLienHe_null: {
        id: 0,
        ten: null,
        dienthoai: null,
        email: null,
        diachi: null,
        chucdanh: null,
        ngaysinh: null,
        favorite: 0,
      },
      itemLienHe: {
        id: 0,
        ten: null,
        dienthoai: null,
        email: null,
        diachi: null,
        chucdanh: null,
        ngaysinh: "",
        favorite: 0,
      },
      modalLienHeShow: false,
      modalLienHeStatus: 0, //0 insert, 1 update
      itemLienHeIdex: -1,
      query: null,
      sortBy: null,
      sortDesc: null,
      totalRow: null,

    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/department"),
        axios.get("/api/customer")
      ])
      .then(
        axios.spread((department, customer) => {
          next((vm) => vm.initData(department.data, customer.data));
        })
      )
      .catch((err) => {
        next();
      });
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/customer", { params: to.query })
      .then((response) => {
        this.items = response.data;
        this.totalRow = this.items.length;
        //Bug khong refresh
        this.openModal();
        this.closeModal();
        // Load page: this.$router.go(0);
        // this.$toast.error(response.data.items, "Lỗi", { timeout: 3000 });
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  computed: {
    count() {
      return this.items.length;
    },
    project_customer_read() {
      return this.$store.getters.hasPermission("project_customer_read");
    },
  },
  methods: {
    changeFavorite() {
      if (this.item.favorite == 0) this.item.favorite = 1;
      else this.item.favorite = 0;
    },
    changeFavoriteItemLienHe() {
      if (this.itemLienHe.favorite == 0) this.itemLienHe.favorite = 1;
      else this.itemLienHe.favorite = 0;
    },

    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      // return temp == null ? "" : temp.tendonvi;
      return temp == null ? "" : temp.madonvi;
    },
    //Filter
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      this.item = null;
      this.$router.push({ query: query });
    },
    sortChanged(ctx) {
      this.item = null;
      let query = Object.assign({}, this.$route.query);
      query.sortBy = ctx.sortBy;
      query.sortDesc = ctx.sortDesc;
      this.$router.push({ query: query });
    },
    initData(departments, data) {
      this.departments = departments;
      this.items = data;
      this.totalRow = this.items.length;
    },
    openModal() {
      this.item = JSON.parse(JSON.stringify(this.item_null));
      this.modalShow = true;
    },
    openUpdateModal(data) {
      this.item = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
    },
    openLienHeModal() {
      this.itemLienHe = JSON.parse(JSON.stringify(this.itemLienHe_null));
      this.modalLienHeStatus = 0;
      this.modalLienHeShow = true;
    },
    openUpdateModalLienHe(data) {
      this.itemLienHe = JSON.parse(JSON.stringify(data.item));
      this.itemLienHe.ngaysinh = this.$convert_date_string(
        this.itemLienHe.ngaysinh
      );
      this.itemLienHeIdex = data.index;
      this.modalLienHeStatus = 1;
      this.modalLienHeShow = true;
    },
    closeModalLienHe() {
      this.modalLienHeShow = false;
    },
    openReportModal() {
      this.reportModalShow = true;
    },
    closeReportModal() {
      this.reportModalShow = false;
    },
    selectCustomer() {
      this.customerModalShow = true;
    },
    closeCustomerModal() {
      this.customerModalShow = false;
    },
    storeItem(bvModalEvt) {
      if (!(this.item.ten && this.item.ten.length)) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.item.id <= 0) {
          const isItemExist = this.items.filter(
            (x) => x.ten.toLowerCase() === this.item.ten.toLowerCase()
          );
          if (isItemExist.length > 0) {
            this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 3000 });
            bvModalEvt.preventDefault();
          } else {
            axios
              .post(this.url, this.item)
              .then((res) => {
                this.modalShow = false;
                this.items.push(res.data);
                this.totalRow = this.items.length;
                this.$toast.success("Thêm thành công !", "Thành công", {timeout: 3000,});
              })
              .catch((err) => {
                this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              });
          }
        } else {
          const isItemUpdateExist = this.items.filter(
            (x) =>
              x.ten.toLowerCase() === this.item.ten.toLowerCase() &&
              x.id !== this.item.id
          );
          if (isItemUpdateExist.length > 0) {
            this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
            bvModalEvt.preventDefault();
          } else {
            axios
              .put(this.url, this.item)
              .then((res) => {
                this.modalShow = false;
                this.items[this.itemIdex] = res.data;
                this.items = JSON.parse(JSON.stringify(this.items));
                this.itemIdex = null;
              })
              .catch((err) => {
                this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              });
          }
        }
      }
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`${this.url + data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.totalRow = this.items.length;
                  this.$toast.success("Xóa thành công!", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    storeItemLienHe(bvModalEvt) {
      if (!(this.itemLienHe.ten && this.itemLienHe.ten.length)) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        const index = this.item.customerContacts.findIndex(
          (x) => x.ten.toLowerCase() === this.itemLienHe.ten.toLowerCase()
        );
        if (index >= 0) {
          this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
          bvModalEvt.preventDefault();
        } else {
          if (this.itemLienHe.ngaysinh != null)
            this.itemLienHe.ngaysinh = this.$convert_string_date(
              this.itemLienHe.ngaysinh
            );
          this.item.customerContacts.push(this.itemLienHe);
          this.modalLienHeShow = false;
          this.$toast.info("Vui lòng nhấn LƯU để hoàn thành cập nhật thông tin", "Nhắc nhở", {timeout: 3000,});
        }
      }
    },
    updateItemLienHe(bvModalEvt) {
      if (!(this.itemLienHe.ten && this.itemLienHe.ten.length)) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        const index = this.item.customerContacts.findIndex(
          (x) => x.ten.toLowerCase() === this.itemLienHe.ten.toLowerCase()
        );
        if (index >= 0 && index != this.itemLienHeIdex) {
          this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
          bvModalEvt.preventDefault();
        } else {
          if (this.itemLienHe.ngaysinh != null)
            this.itemLienHe.ngaysinh = this.$convert_string_date(
              this.itemLienHe.ngaysinh
            );
          this.item.customerContacts[this.itemLienHeIdex] = this.itemLienHe;
          this.item = JSON.parse(JSON.stringify(this.item));
          this.modalLienHeShow = false;
          this.$toast.info("Vui lòng nhấn LƯU để hoàn thành cập nhật thông tin", "Nhắc nhở", {timeout: 3000,});
        }
      }
    },
    deleteItemLienHe(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              this.item.customerContacts.splice(data.index, 1);
              this.$toast.success("Xóa thành công !", "Thành công", {
                timeout: 3000,
              });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.report = 1;
      query.customer = this.customer;
      query.agent_type = this.agent_picked;

      let query_string = `/api/customercontractreport/report`;
      if (this.customer == null && !this.is_all_customer) {
        query_string += `?`;
        for (var cus of this.customers) {
          query_string += `customer_array=${cus.id}&`;
        }
        query_string = query_string.slice(0, -1);
      }

      axios({
        method: "get",
        url: query_string,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {});
    },
    getCustomerFromType(type_id) {
      this.customer_visibled = true;
      this.customer = null;

      if (type_id == 0) {
        this.customers = Object.assign([], this.items);
        this.is_all_customer = true;
      }
      else {
        this.is_all_customer = false;
      }

      axios.get(`/api/customer/customer_type/${type_id}`)
      .then((res) => { this.customers = res.data;})
    },
  },
};
</script>
<style scoped>
</style>
